import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { defaultLayoutComponents } from '~/_v3/common/ui/components/layout/layout';
import { RouteKeys } from '~/router/routes.domain';

export const DocumentsRoute: RouteRecordRaw = {
	name: RouteKeys.DOCUMENTS,
	path: '/documents/:folderId?',
	alias: '',
	components: {
		default: () => import('~/_v3/documents/ui/pages/DocumentsPage.vue'),
		...defaultLayoutComponents
	},
	meta: {
		label: 'documents.navigation',
		icon: () => $i('folder'),
		isNavEntry: true,
		order: 1,
		requiresAuth: true
	}
};
